import type { Subscription } from '../../../types/subscription';

// based on https://github.com/varsitytutors/vt-client-account/blob/master/client/app/scripts/client-account/principles/utils/get-membership-price.js
function getSubscriptionPrice(subscription: Subscription) {
  let priceToDisplay: number;
  let currencyToDisplay;

  if (subscription.promotions?.length) {
    priceToDisplay = subscription.promotions[0].discounted_price_cents;
    currencyToDisplay = subscription.promotions[0].promotion?.amount?.currency_code || 'USD';

    subscription.promotions.forEach((promotion) => {
      if (priceToDisplay < promotion.discounted_price_cents) {
        priceToDisplay = promotion.discounted_price_cents;
        currencyToDisplay = promotion.promotion?.amount?.currency_code || 'USD';
      }
    });

    priceToDisplay /= 100;
  } else {
    priceToDisplay = subscription.purchase_price_cents / 100;
    currencyToDisplay = subscription.currency_code || 'USD';
  }

  return {
    price: priceToDisplay,
    currency: currencyToDisplay,
  };
}

export default getSubscriptionPrice;
